var _defs, _g, _path, _path2, _g2, _path3, _g3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaalToolBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    "data-svgdocument": "",
    id: "_kLW2nt8JJXnaIXFZctHLR",
    className: "fl-svgdocument",
    x: 0,
    y: 0,
    overflow: "hidden",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "_0g4OIv9HG-UwVbfXsxUh2",
    transform: "matrix(1.4899663875406877, 0, 0, 1.4899663875406877, -118.9328106650757, -133.6484692351898)",
    "data-uid": "o_f2h52ga57_4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(20.823056538591167, 0, 0, 20.823056538591167, 6.123321536906005, 28.86332434447791)",
    stroke: "#000000",
    fill: "#FFFFFF",
    strokeWidth: "0.7px",
    "data-uid": "o_f2h52ga57_85"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.5 20.5-7-2v-15l7 2v15zM15.5 18.5l-7 2v-15l7-2v15zM22.5 20.5l-7-2v-15l7 2v15z",
    strokeWidth: "0.7px",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-uid": "o_f2h52ga57_83"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.36493429289363544, 0, 0, 0.36493429289363544, 164.58541246948798, 363.3229300839152)",
    fill: "#FFFFFF",
    "data-type": "rect",
    "data-x": 0,
    "data-y": 0,
    "data-width": 100,
    "data-height": 100,
    d: "M0 0H100 V100 H0 Z",
    "data-uid": "o_f2h52ga57_148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.3845382201785549, 0, 0, 0.3845382201785549, 310.3429819735328, 314.73629524567497)",
    fill: "#FFFFFF",
    "data-type": "rect",
    "data-x": 0,
    "data-y": 0,
    "data-width": 100,
    "data-height": 100,
    d: "M0 0H100 V100 H0 Z",
    "data-uid": "o_f2h52ga57_154"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.021703922811774, -1.5857101684202237, 1.5857101684202237, 19.021703922811774, -36.268240187214644, -119.3951176744333)",
    "data-uid": "o_f2h52ga57_62"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6978520223912503, 0.7162419666875448, -0.7162419666875448, 0.6978520223912503, 16.374045237167824, 3.798230279983109)",
    "data-uid": "o_f2h52ga57_65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5v1",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    transform: "matrix(1, -2.220446049250313e-16, 0, 1.2963603656107738, -0.016377598117109926, -3.239460480182519)",
    "data-uid": "o_f2h52ga57_58"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "2.162 2.162",
    d: "M19.53 13.59c-.4.59-1.15.91-2.53.91-4.59 0-2 7.59-8.93 8.83",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    fill: "none",
    "data-uid": "o_f2h52ga57_59"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5v1",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    transform: "matrix(12.255866866191878, -14.841727300179082, 20.02577983055788, 16.536706714185918, -34.76865791110265, 450.7171690246062)",
    "data-uid": "o_f2h52ga57_91"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5402068570814045, 0, 0, 0.5402068570814045, 117.30189047471225, 28.99589220890701)",
    fill: "#FFFFFF",
    stroke: "#000000",
    "data-uid": "o_f2h52ga57_140"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "20px",
    d: " M455.315 178.812h-198.13c-20.813 0-37.685 16.872-37.685 37.685v122.496c0 30.196-13.534 58.801-36.881 77.951L139.5 452.312 h315.815c20.813 0 37.685-16.872 37.685-37.685v-198.13C493 195.685 476.128 178.812 455.315 178.812z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-uid": "o_f2h52ga57_131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "20px",
    d: " M297.165 146.949c5.253-20.462 16.867-38.983 33.491-52.699L373 59.312l-314.815 0.5c-20.813 0-37.685 16.872-37.685 37.685v198.13 c0 20.813 16.872 37.685 37.685 37.685H189.5",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-uid": "o_f2h52ga57_132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "15px",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-type": "line",
    "data-x1": 79.306,
    "data-y1": 142.523,
    "data-x2": 239,
    "data-y2": 142.523,
    d: "M79.306 142.523L239 142.523",
    "data-uid": "o_f2h52ga57_133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "15px",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-type": "line",
    "data-x1": 159.153,
    "data-y1": 111.812,
    "data-x2": 159.153,
    "data-y2": 142.523,
    d: "M159.153 111.812L159.153 142.523",
    "data-uid": "o_f2h52ga57_134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "15px",
    d: "M205.219 145.594c0 0-12.284 85.989-118.747 126.936M125.372 188.588c15.044 24.447 45.633 57.529 91.768 78.624",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-uid": "o_f2h52ga57_135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "15px",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-type": "polyline",
    d: "M296.98 388.843L355.99 243.588L415 388.843",
    "data-uid": "o_f2h52ga57_137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "15px",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-type": "line",
    "data-x1": 316.145,
    "data-y1": 341.668,
    "data-x2": 394.352,
    "data-y2": 341.668,
    d: "M316.145 341.668L394.352 341.668",
    "data-uid": "o_f2h52ga57_138"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.4632874025315083, 0, 0, 0.4632874025315083, 53.089404272469466, 322.51072351462705)",
    fill: "#026B30",
    "data-type": "circle",
    "data-cx": 50,
    "data-cy": 50,
    "data-r": 50,
    d: "M50,50m-50,0a50,50 0 1, 0 100,0a50,50 0 1, 0 -100,0",
    "data-uid": "o_f2h52ga57_171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5v1",
    stroke: "#026B30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    transform: "matrix(7.098082431934455, -16.285942386530266, 17.92952262661053, 7.814422189911087, -254.92414079269363, 594.1346930753995)",
    "data-uid": "o_f2h52ga57_173"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaalToolBox);
export default __webpack_public_path__ + "static/media/TaalToolBox.8f271c62c9abb3b47998543a61df52a4.svg";
export { ForwardRef as ReactComponent };